module.exports = __webpack_public_path__ + "img/竞店追踪.a34fa405.gif";